import { PayPalButtons, PayPalScriptProvider } from "@paypal/react-paypal-js";
import { useState, useRef } from "react";
import InitApi from "api/InitApi";
import useTokenStore from "store/tokenStore";
import useCurrencyStore from "store/currencyStore";

export default function Paypal({ amount, _onComplete, quotePayload, currency: explicitCurrency }) {
    const { accessToken } = useTokenStore();
    const selectedCurrency = useCurrencyStore((state) => state.currency);
    const currency = explicitCurrency || selectedCurrency;
    const [error, setError] = useState("");
    const acceptedQuote = useRef(null);
    return <div>
        {error && <p role="alert" className="mb-3 text-sm text-red-700">{error}</p>}
        <PayPalScriptProvider key={currency} options={{ "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID, currency, intent: "capture" }}>
            <PayPalButtons createOrder={async (data, actions) => {
                setError("");
                let payable = amount;
                if (quotePayload) {
                    const api = await InitApi({ accessToken });
                    const response = await api.post("/checkout/quotes", { ...quotePayload, currency, payment_method: "PayPal" });
                    const quote = response.data.data;
                    // A changed displayed price must be reviewed before payment starts.
                    if (Number(quote.total_amount) !== Number(amount)) {
                        setError(`The price changed to ${quote.total_amount} ${currency}. Refresh checkout to review the new total.`);
                        throw new Error("Checkout price changed");
                    }
                    const accepted = await api.post(`/checkout/quotes/${quote.quote_id}/accept`);
                    acceptedQuote.current = accepted.data.data;
                    payable = acceptedQuote.current.total_amount;
                }
                return actions.order.create({ purchase_units: [{ amount: { currency_code: currency, value: String(payable) } }] });
            }} onApprove={async (data, actions) => {
                const order = await actions.order.capture();
                const captured = order.purchase_units?.[0]?.payments?.captures?.[0]?.amount;
                if (captured && (captured.currency_code !== currency || Number(captured.value) !== Number(acceptedQuote.current?.total_amount ?? amount))) {
                    setError("Payment details differ from your quote. Contact support with your payment reference.");
                    return;
                }
                await _onComplete(order, acceptedQuote.current);
            }} onError={() => setError((current) => current || "PayPal could not complete this payment. Please try again.")} />
        </PayPalScriptProvider>
    </div>;
}
